import React, { Component } from "react";
import ConsultCard from "../../MedicalHistory/ConsultCard";
import LoadMask from 'Utils/LoadMask/LoadMask';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
export default class ConsultSheet extends Component {
  componentWillUnmount() {
      this.props.resetStore();
  }

  componentWillMount() {    
      if (this.props.match.params.id) {
          this.props.getConsultSheet(this.props.match.params.id);
      }
  }
  
  
  generarPDF = async () => {
    const element = document.getElementById("contenido-pdf");
  
    const canvas = await html2canvas(element, {
      scale: 1, // Mejor calidad
      useCORS: true
    });
  
    const imgData = canvas.toDataURL("image/jpeg");
  
    const pdf = new jsPDF("p", "mm", "a4");
   
    const pageWidth = 210;
    const pageHeight = 297;
  
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
    let heightLeft = imgHeight;
    let position = 0;
   
    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
  
    //pdf.save("reporte.pdf");
    const pdfBlob = pdf.output("blob");    
    const pdfFile = new File(
      [pdfBlob],
      "resumen_de_consulta.pdf",
      {
        type: "application/pdf",
        lastModified: Date.now()
      }
    );

    this.props.sendIggsEmail(this.props.match.params.id, pdfFile)
  }

  render(){
    const handlePrint = () => {      
      window.print();      
      window.close();
    };

    const { consult_sheet } = this.props;
    const signature = consult_sheet ? consult_sheet.doctor ? consult_sheet.doctor.signature : null : null;

    //console.log("CONSULT SHEET SIMPSON .:::. ", consult_sheet);
    
    return(
      <React.Fragment>
        <LoadMask loading={this.props.loader}>
        <div
            className="dont-print"
            style={{
                display: "flex",
                justifyContent: "right",
                margin: "20px 20px 20px 0px",
            }}
        >
            <button
                className="btn btn-primary ml-3 mr-3"
                style={{
                    maxWidth: "100px",
                }}                
                onClick={handlePrint}
            >
                IMPRIMIR
            </button>

            {consult_sheet && consult_sheet.igss_form &&
            <React.Fragment>
              {!consult_sheet.sended_igss_email ?
                <button
                    className="btn btn-success ml-3 mr-3"
                    style={{
                        maxWidth: "100px",
                        fontSize: '12px',
                        fontWeight: 700
                    }}       
                    onClick={this.generarPDF}
                    disabled={this.props.loader}
                >
                    ENVIAR AL IGSS  {this.props.loader}
                </button>
                :
                <button
                  className="btn btn-success ml-3 mr-3"
                  style={{
                      maxWidth: "100px",
                      fontSize: '12px',
                      fontWeight: 700
                  }}
                  disabled={true}
                >
                  ENVIADO
                </button>
              }
            </React.Fragment>
            }
        </div>
        <div          
          className="print-area"
          style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "black"
          }}
        >
          <div
            className="print-content"
            id="contenido-pdf"
            style={{
                width: "80%",
                margin: "0 auto",
                height: "100%",
                //backgroundColor: "yellow",                  
            }}
          >
            {this.props.consult_sheet &&          
              <React.Fragment>
                <ConsultCard consult={this.props.consult_sheet} restrictHeight={false} hiddePrintButton signature={signature} />               
              </React.Fragment>
            }            

            {/*signature &&
                <div 
                    id="firma"
                    style={{
                        display: 'flex',                
                        justifyContent: 'center',
                        alignItems: 'center',                                
                        filter: 'contrast(1.05) brightness(1.02)'
                    }}
                >
                {
                <img 
                    src={typeof signature === 'string' ? signature : URL.createObjectURL(signature)} 
                    alt="Firma" 
                    style={{maxWidth: '300px', maxHeight: '150px', objectFit: 'contain'}}
                />
                }
                </div>
              */}            
          </div>          
        </div>
        </LoadMask>
      </React.Fragment>
    )
  }
}